/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

interface Props {
	label: string;
	icon: string;
	color?: string;
	val: string;
	status: string;
}
const ReconMediaDetailStatCard: React.FC<Props> = ({ label, icon, color, val, status }) => {
	return (
		<div
			className="bg-white px-6 py-3 h-[96px] rounded-2xl border border-slate-200 shadow-sm flex flex-col gap-1 hover:shadow-lg transition-all"
		>
			<div className="flex justify-between items-center -mt-2">
				<span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
					{label}
				</span>
				<span className="material-symbols-outlined text-slate-300 text-base">
					{icon}
				</span>
			</div>
			<p
				className={`text-xl font-black -mt-1 ${color || "text-slate-800"}`} 
			>
				{val}
			</p>
			<span className="text-[9px] font-black uppercase bg-slate-100 text-slate-500 px-1 -mt-3 rounded w-fit">
				{status}
			</span>
		</div>
	);
};

export default ReconMediaDetailStatCard;
